import React, { useEffect, useState } from 'react';
import './styles.scss';
import PropTypes from 'prop-types';
import { noop } from '../../common/propTypes';
import ChallengeList from '../../common/ChallengesList/';
import LoadingComponent from '../../common/LoadingComponent/';
import { connect } from 'react-redux';
import {
    getChallenges,
    getChallengesLoading,
    getParticipatedChallenges,
} from './selectors';
import {
    getUserPermissionRoleId,
    getUserPermissionsKeys,
} from './../../screens/auth/selectors';
import {
    challengesRequested,
    challengeUpdateRequested,
    participatedChallengesRequested,
} from './actions';
import challengePropTypes from '../../common/ChallengeRow/propTypes';
import Button from '../../common/Button';
import { useHistory } from 'react-router';
import { ROUTE_CHALLENGE_CREATE } from '../../navigation/constants';
import { ROLE_PARTNER, ROLE_SUPER_ADMIN } from '../auth/constants';
import { setSelectedChallenge } from '../Challenge/actions';
function Challenges({
    onLoad,
    challenges,
    onActiveToggle,
    challengesLoading,
    participated,
    permissions,
    loadParticipatedChallenges,
    currentRole,
    setChallenge,
}) {
    // use effect is called only when the component mounts
    useEffect(() => {
        window.scrollTo(0, 0);
        onLoad();
        if (permissions.includes('challenge_participating_list')) {
            loadParticipatedChallenges();
        }
        setChallenge({});
    }, []);
    // state to extract global and connected challenges from API response
    const [globalChallenges, setGlobalChallenges] = useState([]);
    const [localChallenges, setLocalChallenges] = useState([]);
    const [connectedChallenges, setConnectedChallenges] = useState([]);
    const [activeChallenges, setActiveChallenges] = useState([]);
    const [archiveChallenges, setArchiveChallenges] = useState([]);
    const history = useHistory();
    // this hook is called only when challenges props changes
    // this helps update the internal state of global and connected challenges
    useEffect(() => {
        setGlobalChallenges(
            challenges.filter((challenge) => {
                if (challenge.type === 'FEATURED') return challenge;
            }),
        );
        setLocalChallenges(
            challenges.filter((challenge) => {
                if (challenge.type === 'LOCAL') return challenge;
            }),
        );
        setConnectedChallenges(
            challenges.filter((challenge) => {
                if (challenge.type === 'CONNECTED') return challenge;
            }),
        );
        setArchiveChallenges(
            challenges.filter((challenge) => {
                if (!challenge.isActive) return challenge;
            }),
        );
        setActiveChallenges(
            challenges.filter((challenge) => {
                if (challenge.isActive) return challenge;
            }),
        );
    }, [challenges]);

    const loader = (
        <div className="challengesLoader">
            <LoadingComponent isLoading={challengesLoading} />
        </div>
    );

    const renderChallenges = (challenges, onActiveToggle) => {
        return challenges && challenges.length ? (
            <ChallengeList
                challenges={challenges}
                onActiveToggle={onActiveToggle}
            />
        ) : (
            <h4 className="text-center">No Challenges found</h4>
        );
    };

    return (
        <div>
            <h1>Challenges</h1>
            <div className="col">
                <div className="tab-wrapper">
                    <ul
                        className="nav nav-tabs position-relative"
                        id="myTab"
                        role="tablist"
                    >
                        <li className="nav-item">
                            <a
                                className="nav-link  active"
                                id="tab-04"
                                data-toggle="tab"
                                href="#active"
                                role="tab"
                                aria-controls="active"
                                aria-selected="false"
                            >
                                Active
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className="nav-link"
                                id="tab-02"
                                data-toggle="tab"
                                href="#featured"
                                role="tab"
                                aria-controls="featured"
                                aria-selected="false"
                            >
                                Featured
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className="nav-link"
                                id="tab-03"
                                data-toggle="tab"
                                href="#connected"
                                role="tab"
                                aria-controls="connected"
                                aria-selected="false"
                            >
                                Connected
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className="nav-link"
                                id="tab-07"
                                data-toggle="tab"
                                href="#local"
                                role="tab"
                                aria-controls="local"
                                aria-selected="false"
                            >
                                Local
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className="nav-link"
                                id="tab-05"
                                data-toggle="tab"
                                href="#archived"
                                role="tab"
                                aria-controls="archived"
                                aria-selected="false"
                            >
                                Archived
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className="nav-link"
                                id="tab-01"
                                data-toggle="tab"
                                href="#all"
                                role="tab"
                                aria-controls="all"
                                aria-selected="true"
                            >
                                All
                            </a>
                        </li>

                        {permissions.includes(
                            'challenge_participating_list',
                        ) && (
                            <li className="nav-item">
                                <a
                                    className="nav-link"
                                    id="tab-06"
                                    data-toggle="tab"
                                    href="#participated"
                                    role="tab"
                                    aria-controls="archived"
                                    aria-selected="false"
                                >
                                    Participating
                                </a>
                            </li>
                        )}
                        {[ROLE_PARTNER, ROLE_SUPER_ADMIN].includes(
                            +currentRole.toString().split('')[0],
                        ) && (
                            <Button
                                variant="ml-auto main btn-create-challeng"
                                value="Create a Challenge"
                                onClick={() =>
                                    history.push(ROUTE_CHALLENGE_CREATE)
                                }
                            />
                        )}
                    </ul>
                    <div className="tab-content" id="myTabContent">
                        <div
                            className="tab-pane fade"
                            id="all"
                            role="tabpanel"
                            aria-labelledby="tab-01"
                        >
                            <ul className="list-style">
                                {challengesLoading
                                    ? loader
                                    : renderChallenges(
                                          challenges,
                                          onActiveToggle,
                                      )}
                            </ul>
                        </div>
                        <div
                            className="tab-pane fade"
                            id="featured"
                            role="tabpanel"
                            aria-labelledby="tab-02"
                        >
                            <ul className="list-style">
                                {challengesLoading
                                    ? loader
                                    : renderChallenges(
                                          globalChallenges,
                                          onActiveToggle,
                                      )}
                            </ul>
                        </div>
                        <div
                            className="tab-pane fade"
                            id="connected"
                            role="tabpanel"
                            aria-labelledby="tab-03"
                        >
                            <ul className="list-style">
                                {challengesLoading
                                    ? loader
                                    : renderChallenges(
                                          connectedChallenges,
                                          onActiveToggle,
                                      )}
                            </ul>
                        </div>
                        <div
                            className="tab-pane fade show active"
                            id="active"
                            role="tabpanel"
                            aria-labelledby="tab-04"
                        >
                            <ul className="list-style">
                                {challengesLoading
                                    ? loader
                                    : renderChallenges(
                                          activeChallenges,
                                          onActiveToggle,
                                      )}
                            </ul>
                        </div>
                        <div
                            className="tab-pane fade"
                            id="archived"
                            role="tabpanel"
                            aria-labelledby="tab-05"
                        >
                            <ul className="list-style">
                                {challengesLoading
                                    ? loader
                                    : renderChallenges(
                                          archiveChallenges,
                                          onActiveToggle,
                                      )}
                            </ul>
                        </div>
                        <div
                            className="tab-pane fade"
                            id="participated"
                            role="tabpanel"
                            aria-labelledby="tab-06"
                        >
                            <ul className="list-style">
                                {challengesLoading
                                    ? loader
                                    : renderChallenges(
                                          participated,
                                          onActiveToggle,
                                      )}
                            </ul>
                        </div>
                        <div
                            className="tab-pane fade"
                            id="local"
                            role="tabpanel"
                            aria-labelledby="tab-07"
                        >
                            <ul className="list-style">
                                {challengesLoading
                                    ? loader
                                    : renderChallenges(
                                          localChallenges,
                                          onActiveToggle,
                                      )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

Challenges.propTypes = {
    // Function to be called when the Component/Screen loads
    onLoad: PropTypes.func,

    // Function to be called when the Active Toggle state is updated
    onActiveToggle: PropTypes.func,

    // Challenges to be displayed
    challenges: PropTypes.arrayOf(
        PropTypes.shape({
            ...challengePropTypes,
            isGlobal: PropTypes.bool,
            isConnected: PropTypes.bool,
            isActive: PropTypes.bool,
            isMemeber: PropTypes.bool,
        }),
    ),
    participated: PropTypes.arrayOf(
        PropTypes.shape({
            ...challengePropTypes,
            isGlobal: PropTypes.bool,
            isConnected: PropTypes.bool,
            isActive: PropTypes.bool,
            isMemeber: PropTypes.bool,
        }),
    ),
    // boolean to represent the screen loading state
    challengesLoading: PropTypes.bool,
    permissions: PropTypes.array,
    loadParticipatedChallenges: PropTypes.func,
    currentRole: PropTypes.number,
    setChallenge: PropTypes.func,
};

Challenges.defaultProps = {
    onLoad: noop,
    onActiveToggle: noop,
    challenges: [],
    participated: [],
    challengesLoading: false,
    permissions: [],
    loadParticipatedChallenges: noop,
    currentRole: 0,
    setChallenge: noop,
};

const mapStateToProps = (state) => {
    return {
        challenges: getChallenges(state),
        challengesLoading: getChallengesLoading(state),
        participated: getParticipatedChallenges(state),
        permissions: getUserPermissionsKeys(state),
        currentRole: getUserPermissionRoleId(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setChallenge: (challenge) => dispatch(setSelectedChallenge(challenge)),
        onLoad: () => dispatch(challengesRequested()),
        loadParticipatedChallenges: () =>
            dispatch(participatedChallengesRequested()),
        onActiveToggle: (index) => dispatch(challengeUpdateRequested(index)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Challenges);
